import {useEffect} from "react";
import {useNavigate} from 'react-router-dom';
import {Box,Grid,Button,Typography} from '@mui/material';
import {useKeycloak} from "@react-keycloak/web";
import {useApplication} from '../../custom/components/ApplicationContext.js';
import {getStringLang} from '../utilities/Strings.js';//CORE
import {getCookie} from '../utilities/Utilities.js';//CORE
const language=getCookie('preferredLanguage')||'en';

const Home=({roleConfig})=>{
    const {keycloak,initialized}=useKeycloak();
    const isLoggedIn=keycloak.authenticated;
    const navigate=useNavigate();
    const {globalData}=useApplication();
    const application={globalData,getLocale:(key,options)=>globalData?.getLocale(key,options)};

    useEffect(()=>{
        const params=new URLSearchParams(window.location.search);
        const isPostRegister=params.get("postRegister")==="true";
        const loginHint=params.get("loginHint");
        if(isPostRegister&&!isLoggedIn){
            keycloak.login({
                loginHint:loginHint||undefined,
                redirectUri:window.location.origin,
                flow:'standard'
            });
        }
    },[isLoggedIn,keycloak]);

    useEffect(()=>{
        const params=new URLSearchParams(window.location.search);
        const isPostRegister=params.get("postRegister")==="true";
        if(isLoggedIn&&roleConfig&&(localStorage.getItem('handleLoginClicked')==='Y'||isPostRegister)){
            localStorage.setItem('handleLoginClicked','N');
            if(isPostRegister){
                //window.history.replaceState({}, document.title, window.location.pathname);
            }
            navigate(roleConfig.landingPage);
        }
    },[isLoggedIn,roleConfig,navigate]);

    if(!initialized) return null;

    const handleLogin=()=>{
        localStorage.setItem('handleLoginClicked','Y');
        keycloak.login();
    }
    
    const connected=()=>{
        return <Typography color={'darkblue'} variant="h3" gutterBottom>{globalData&&application.getLocale("Connected")}</Typography>;
    }
    const desconnected=()=>{
        return <Typography color={'red'} variant="h3" gutterBottom>{getStringLang('NotConnected',language)+(localStorage.getItem('sessionExpiredMessage')!==''?getStringLang('SessionExpired',language):'')}</Typography>
    }

    return (
        <Box sx={{p:2}}>
            <Grid
                container
                direction="column"
                rowSpacing={4}
                justifyContent="center"
                alignItems="center">
                <Grid style={{marginTop:'50px'}}>
                    {isLoggedIn?connected():(isLoggedIn===undefined?null:desconnected())}
                </Grid>
                <Grid>
                    {isLoggedIn===false&&<Button variant="contained" size="large" sx={{fontSize:'1.0rem',}} onClick={handleLogin}>{getStringLang('Login',language)}</Button>}
                </Grid>
            </Grid>
        </Box>
    )
}

export default Home
